import React, { useState, useEffect, useContext, useMemo ,useCallback } from 'react';
import { Icon, Upload, message, Steps, Button, Dropdown, Menu } from 'antd';
import Lottie from 'react-lottie';
import { pdfAnimationData } from './lottieFiles';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
  TemplatePageOverview,
  TemplateImage,
  ErrorMessage,
  BulkUploadButton,
  UploadSteps,
  TemplateTitleSec,
  TempDetails,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import Loader from '../../components/Loader';
import { getAllPublishedDocuments } from '../../utils/services/templatesAPI';
import { staticDownload, uploadDataSetTransaction } from '../../utils/services/documentAPI';
import VariableDetailsModal from '../../components/Modals/VariableDetailsModal';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { PDFSvg } from '../../components/SidebarMenuIcons';
import { PDF_TRANSACTIONS, TRANSACTIONS } from './translationValues';
import { withTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import { VARIABLE_TYPE } from '../../utils/constants/appConstants';
import { throttle } from 'underscore';
import { jsonToFile } from '../../utils/javascript';
import { getTagsList } from '../../utils/services/mailRoomAPI';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { SUPPORT_EMAIL_ID } from '../../utils/helper';
import { getPayloadFromFile, getXMLFromJSON } from '../../utils/transactionHelpers';
import { xmlToFile, toZipFile} from '../../utils/javascript';
import { dynamicTableHasMoreThanTwoLevels } from '../ComplexDocumentDesign/complexDocumentHelper';
import { getSampleDataSet, generateCSVHeadersFromJSON, downloadDelimitedFile, generatePayloadFromCsvFile, parseFileWithKnownDelimiters } from '../../utils/helper';
import { checkFileFormat } from '../../utils/transactionHelpers';

const NAMESPACES = [
  'TRANSACTIONS',
  'PDF_TRANSACTIONS',
  'EMAIL_TRANSACTIONS',
  'CALL_TRANSACTIONS',
  'MESSAGE_TRANSACTIONS',
  'WHATSAPP_TRANSACTIONS',
];
const GeneratePdf = props => {
  const { tempCategories, page, filterByCateg, searchVal, searchTag, onTempSelection, t } = props;
  const { loginVisible, checkUserAccess, userDetails, globalVariables } = useContext(AppStoreContext);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [totalTemplates, setTotalTemplates] = useState(null);
  const [templatesList, setTemplatesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage] = useState('');
  const [generatingPdf, setIsgeneratingPdf] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isViewVarDetails, setIsViewVarDetails] = useState(false);
  const [tagsData, setTagsData] = useState([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const transactionLimit = userDetails?.planMapping?.transactionLimit;
  const { Step } = Steps;
  const windowSize = window.innerWidth;

  const isMailRoomModuleEnabled = checkUserAccess('client', ['MAILROOMADMIN', 'MAILROOMCLIENT']);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: pdfAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    (async () => {
      setCurrentStep(0);
      setIsLoading(page === 1 && true);

      let payload = {
        includeVariables: true,
        page: page,
        limit: windowSize > 1440 && windowSize < 2560 ? 12 : 9,
      };
      if (searchVal) {
        payload.name = searchVal;
      }
      if (searchTag) {
        payload.tags = searchTag;
      }
      if (filterByCateg) {
        payload.categoryIds = filterByCateg;
      }
      let response = await getAllPublishedDocuments(payload);
      if (response && response.data) {
        let templateData;
        if (payload.page > 1) {
          templateData = templatesList.concat(response.data);
        } else {
          templateData = response.data;
        }
        setTemplatesList(templateData);
        setTotalTemplates(response.dataCount);
      }

      tempCategories.length > 0 && setIsLoading(false);
    })();
  }, [loginVisible, page, filterByCateg, searchVal, searchTag, windowSize, tempCategories.length]);

  useEffect(() => {
    (async () => {
      if (isMailRoomModuleEnabled) {
        let tagsData = await getTagsList();
        if (tagsData && tagsData.data) {
          setTagsData(tagsData?.data);
        }
      }
    })();
  }, [isMailRoomModuleEnabled]);

  useEffect(() => {
    setIsLoading(true);
    if (tempCategories.length > 0) {
      setIsLoading(false);
    }
  }, [tempCategories]);

  const [isRepeatedBlocks, isChartBlock] = useMemo(() => {
    if (selectedTemplate && selectedTemplate.variableContract.length > 0) {
      const hasRepeatedBlocks = selectedTemplate.variableContract.some(
        variable => variable.type === VARIABLE_TYPE.OBJECT,
      );
      const hasChartBlock = selectedTemplate.variableContract.some(
        variable => variable.type === VARIABLE_TYPE.CHART_OBJECT,
      );
      return [hasRepeatedBlocks, hasChartBlock];
    }
    return [false, false];
  }, [selectedTemplate]);


  const debouncedHandleDownload = useCallback(throttle(templateObj => noVariableDocumentDownload(templateObj), 1000, { leading: true, trailing: false }), []);

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        <TemplateTitleSec isPublishedTemp={1}>
          <p className={'template_title'}>
            {t(
              `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.PDF_TRANSACTIONS_TITLE.key}`,
              PDF_TRANSACTIONS.PDF_TRANSACTIONS_TITLE.value,
            )}
          </p>
        </TemplateTitleSec>
        {isLoading ? (
          <LoaderContainer style={{ marginTop: '25%' }}>
            <Loader />
          </LoaderContainer>
        ) : (
          templatesList?.length > 0 && (
            <>
              <TemplateWrapper isUploadFile={1}>
                {templatesList.map(templateObj => {
                  return (
                    <div key={templateObj.id}>
                      <div>
                        <TemplatePageOverview
                          uploadExcel={1}
                          className={
                            selectedTemplate && selectedTemplate.id === templateObj.id && 'selected'
                          }
                          key={templateObj.id}
                          title={templateObj.name}
                          onClick={() => {
                            try {
                              setSelectedTemplate(templateObj);

                              if (templateObj?.variableContract?.length === 0) {
                                userDetails.isTransactionFull ?
                                  handleLimitExceeded()
                                  : debouncedHandleDownload(templateObj);
                              }
                              if (templateObj?.variableContract?.length > 0) {
                                onTempSelection(currentStep + 1);
                                setCurrentStep(currentStep + 1);
                              }
                            } catch (e) {
                              console.log('error on clicking publish template!! ', e);
                            }
                          }}
                        >
                          <TemplateImage uploadExcel={1}>
                            <Icon component={PDFSvg} />
                          </TemplateImage>
                          <div className="template_name">
                            <div className="name">{templateObj.name} </div>
                            <div className="categoryName">
                              <div className="box2"></div>
                              {categoriesTemp.length > 0 &&
                                categoriesTemp.map(
                                  category =>
                                    templateObj.categoryId === category.categoryId && (
                                      <div className="categ_Name" key={category.categoryId}>
                                        {category.categoryName}
                                      </div>
                                    ),
                                )}
                            </div>
                          </div>
                        </TemplatePageOverview>
                      </div>
                    </div>
                  );
                })}
              </TemplateWrapper>
            </>
          )
        )}
        {!isLoading && templatesList?.length === 0 && (
          <EmptySettingsDetails style={{ marginTop: '25%' }}>
            <div className="empty-illustration">
              <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
            </div>
            <div className="empty-txt" style={{ color: 'black' }}>
              <span>
                {t(
                  TRANSACTIONS.TEMPLATE_LIST_EMPTY_MESSAGE.key,
                  TRANSACTIONS.TEMPLATE_LIST_EMPTY_MESSAGE.value,
                )}
              </span>
            </div>
          </EmptySettingsDetails>
        )}
      </React.Fragment>
    );
  };

  const renderSearchBody = () => {
    return (
      <React.Fragment>
        <UploadSteps currentStep={currentStep > 0}>
          <Steps current={currentStep} direction="vertical">
            {steps.map(item => (
              <Step key={item.title} title={item.title} />
            ))}
            <Lottie
              options={defaultOptions}
              className="lottie"
              height="40%"
              width="50%"
              style={{ marginTop: '50%' }}
              speed={0.3}
              isStopped={false}
              isPaused={false}
            />
          </Steps>
          <div className="uploadSection">
            <div className="steps-content" style={{ width: '70vw' }}>
              {steps[currentStep].content}
            </div>
            <div className={`${currentStep > 0 ? 'previous steps-action' : 'next steps-action'}`}>
              {currentStep > 0 && (
                <Button
                  style={{ marginLeft: 8 }}
                  onClick={() => {
                    onTempSelection(currentStep - 1);
                    setCurrentStep(currentStep - 1);
                  }}
                >
                  {t(
                    TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.key,
                    TRANSACTIONS.MOVE_TO_SELECT_A_TEMPLATE_STEP_BUTTON.value,
                  )}
                </Button>
              )}
            </div>
          </div>
        </UploadSteps>
      </React.Fragment>
    );
  };

  const getDistinctItemsByVariableId = inputArray => {
    const uniqueVariableIds = new Set();

    // Use filter() to get distinct items based on 'variableid'
    return inputArray.filter(item => {
      if (!uniqueVariableIds.has(item.name)) {
        uniqueVariableIds.add(item.name);
        return true;
      }
      return false;
    });
  };

  const onBatchResponse = useCallback(response => {
    if (response && response.statusCode === 200) {
      message.config({ duration: 6 });
      // TODO : Add to namespace
      message.success(
        t(
          PDF_TRANSACTIONS.BATCH_UPLOAD_SUCCESS_MESSAGE.key,
          PDF_TRANSACTIONS.BATCH_UPLOAD_SUCCESS_MESSAGE.value,
        ),
      );
      message.config({ duration: 1.5 });
    } else {
      // TODO : Add to namespace
      message.error('Error in submitting batch request!!');
    }
    setIsgeneratingPdf(false);
  }, []);

  const handleResponse = async response => {
    const partialSuccess = response?.statusCode === 709 && response?.errors?.some(error => error?.code === 503);

    if (response?.statusCode === 4000 || partialSuccess) {
      message.destroy();
      setIsgeneratingPdf(false);
      if (partialSuccess) { // Partial success; the remaining attempts failed due to exceeding the limit.
        window.open(response?.data);
      }
      handleLimitExceeded();
      return;
    }

    if (!response || !response.data) {
      if (!response) {
        message.error(
          t(
            PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.key,
            PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.value,
          ),
        );
      } else {
        message.error(
          t(
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key,
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
          ),
        );
      }
      setIsgeneratingPdf(false);
      return;
    }

    if (response && (!response.errors || response.errors.length === 0)) {
      message.success(
        t(
          PDF_TRANSACTIONS.PDF_GENERATION_SUCCESS.key,
          PDF_TRANSACTIONS.PDF_GENERATION_SUCCESS.value,
        ),
      );

      if (!response.data?.baseUrl || !response.data?.fileNames?.[0]) {
        message.error(
          t(
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key,
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
          ),
        );
        setIsgeneratingPdf(false);
        return;
      }

      const url = response.data.baseUrl + response.data.fileNames[0] + "?" + response.data?.token;

      try {
        const fetchResponse = await fetch(url);

        if (!fetchResponse.ok) {
          throw new Error(`HTTP error! status: ${fetchResponse.status}`);
        }

        const blob = await fetchResponse.blob();

        if (!blob || blob.size === 0) {
          throw new Error('Downloaded file is empty');
        }

        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;

        let filename = response.data.fileNames[0];
        if (!filename.toLowerCase().endsWith('.pdf')) {
          filename += '.pdf';
        }
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke with small delay to ensure download starts
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 100);
      } catch (error) {
        console.error('Download failed:', error);
        message.error(
          t(
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key,
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
          ),
        );
      } finally {
        setIsgeneratingPdf(false);
      }
    } else {
      message.error(
        t(
          PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key,
          PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
        ),
      );
      setIsgeneratingPdf(false);
    }
  };

  const noVariableDocumentDownload = async templateObj => {
    let payload = [
      {
        documentId: templateObj.id,
        dataSet: {},
      },
    ];
    message.info(
      t(PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.key, PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.value),
    );
    const response = await uploadDataSetTransaction(templateObj.name, payload, true);
    handleResponse(response);
  };

  const generateSampleExcel = () => {
    const { variableContract } = selectedTemplate;
    const isMailRoomModuleEnabled = false;
    const tagsData = undefined;
    const {isNestedTable} = dynamicTableHasMoreThanTwoLevels(variableContract);
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([]);

    // Add data to worksheet
    let col = 0;
    if (isRepeatedBlocks || isChartBlock) {
      XLSX.utils.sheet_add_aoa(ws, [['id']], {
        origin: { r: 0, c: col++ },
      });
    }
    XLSX.utils.sheet_add_aoa(ws, [['uniq_id']], {
      origin: { r: 0, c: col++ },
    });
    XLSX.utils.sheet_add_aoa(ws, [['uniq_name']], {
      origin: { r: 0, c: col++ },
    });

    // Add main headers and subheaders
    variableContract.forEach(item => {  
      if (item.type === VARIABLE_TYPE.STRING_TITLE_CASE || item.type === VARIABLE_TYPE.STRING || item.type === VARIABLE_TYPE.LIST_OF_STRINGS || item.type === VARIABLE_TYPE.DATE.toLowerCase() || item.type === VARIABLE_TYPE.HTML) {       
        XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
          origin: { r: 0, c: col },
        });
        col++;
      } else if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.CHART_OBJECT) {
        const addCell = (row, value) => {
          XLSX.utils.sheet_add_aoa(ws, [[value]], { origin: { r: row, c: col } });
        };

        item.content.forEach(subItem => {
          let isRepeatedBlocks = false;
          let isChartBlock = false;
          if (selectedTemplate && selectedTemplate.variableContract?.length > 0) {
            isRepeatedBlocks = selectedTemplate.variableContract.some(
              variable => variable.type === VARIABLE_TYPE.OBJECT && variable.content.length > 0,
            );
            isChartBlock = selectedTemplate.variableContract.some(
              variable =>
                variable.content?.some(
                  v => v.type === VARIABLE_TYPE.CHART_OBJECT && v.content.length > 0,
                )
            );
          }

          if (subItem?.content && (isNestedTable || isRepeatedBlocks || isChartBlock)) {
            if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.TABLE_OBJECT) {
              addCell(0, item.name);
              addCell(1, `table_id`);
              col++;
            }

            if (isRepeatedBlocks) {
              subItem.content.forEach(innerChild => {
                addCell(0, item.name);
                if (isChartBlock && subItem.type === VARIABLE_TYPE.CHART_OBJECT) {
                  addCell(1, `${subItem.name}.${innerChild.name}`);
                } else {
                  addCell(1, `${item.name}.${innerChild.name}`);
                }
                col++;
              });
            } else {
              subItem.content.forEach(innerChild => {
                addCell(0, item.name);
                addCell(1, item.type === VARIABLE_TYPE.OBJECT ? innerChild.name : `${item.name}.${innerChild.name}`);
                col++;
              });
            }
          } else {
            addCell(0, item.name);
            addCell(1, subItem.name);
            col++;
          }
        });
      }
    });
    if (isMailRoomModuleEnabled && tagsData) {
      const tags = tagsData.map(item => item.tagName);
      XLSX.utils.sheet_add_aoa(ws, [['printable', ...tags]], {
        origin: { r: 0, c: col++ },
      });
    }
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate Excel file
    XLSX.writeFile(wb, `${selectedTemplate.name}.xlsx`);
  };

  const getFlatFilesPayload = async (file) => {
    const { data, delimiter } = await parseFileWithKnownDelimiters(file);
    const payload = generatePayloadFromCsvFile(data, selectedTemplate.variableContract, 'live', selectedTemplate?.id);
    return payload;
  }

  const beforeUpload = async file => {

    let requests;
    if (file) {
      const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
      if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
        requests = await getFlatFilesPayload(file);
        if (requests && requests?.length > 0) {
          setIsgeneratingPdf(true);
          const uploadFilesLength = requests?.length;
          const synchronous = !requests || requests?.length <= 10;
            message.config({ duration: 8 });
            const response = await uploadDataSetTransaction(selectedTemplate?.name, requests, synchronous);
            if (synchronous && response?.statusCode === 200) {
              const directDownloadPayload = response?.data;
              const directDownloadResponse = await staticDownload(directDownloadPayload);
              if (directDownloadResponse?.status === 200) {
                toZipFile(directDownloadResponse?.data, `${selectedTemplate['name']}`)
                uploadFilesLength === response?.data?.fileNames?.length ? message.success(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.value)) :
                  message.success(t(PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.key,
                    PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.value, { Downloaded_file: response.data.fileNames.length, Actual_files: uploadFilesLength }
                  ))
              }
              else if (directDownloadResponse?.status === 500) {
                message.error(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.value))
              }
              setIsgeneratingPdf(false);
              message.config({ duration: 1.5 });
              !directDownloadResponse && onBatchResponse(response);
            }
            message.config({ duration: 1.5 });
            (!synchronous || response?.statusCode === 4005) && onBatchResponse(response);
        }
        else {
          message.error(
            t(
              TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key,
              TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
            ),
          );
        }
        setIsgeneratingPdf(false);
        return;
      }
    }
    const reader = new FileReader();
    reader.onload = async event => {
      const binaryString = event.target.result;
      requests = getPayloadFromFile(binaryString, file, selectedTemplate, t, false, isMailRoomModuleEnabled, tagsData);
      setIsUploading(false);
      setIsgeneratingPdf(true);

      if(!requests){
        setIsUploading(false);
        setIsgeneratingPdf(false);
      }

      if (requests === false) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key}`,
            TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.value,
          ),
        );
        return;
      }
      const uploadFilesLength=requests?.length
      const synchronous = !requests || requests?.length <= 10;
      if (requests) {
        message.config({ duration: 8 });
        // TODO : Include mailroom in the xml and json?
        const response = await uploadDataSetTransaction(selectedTemplate?.name, requests.map(req => Object.assign({}, req, { documentId: selectedTemplate?.id })),synchronous);
        if (synchronous && response?.statusCode === 200) {
          const directDownloadPayload = response?.data;
          const directDownloadResponse = await staticDownload(directDownloadPayload);
          if (directDownloadResponse?.status === 200) {
            toZipFile(directDownloadResponse?.data, `${selectedTemplate['name']}`)
            uploadFilesLength === response?.data?.fileNames?.length ? message.success(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.value)) :
              message.success(t(PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.key,
                PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.value, { Downloaded_file: response.data.fileNames.length, Actual_files: uploadFilesLength }
              ))
          }
          else if (directDownloadResponse?.status === 500) {
            message.error(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.value))
          }
          setIsgeneratingPdf(false);
          message.config({ duration: 1.5 });
          !directDownloadResponse && onBatchResponse(response);
        }
        message.config({ duration: 1.5 });
        (!synchronous || response?.statusCode === 4005) && onBatchResponse(response);
      }
    };
    reader.readAsBinaryString(file);
    setIsUploading(false);
    setIsgeneratingPdf(false);
    return false; // Prevent default upload behavior
  };

  const getSampleValue = (variableId) => {
    const samplevalue = globalVariables.find(list => list.id === variableId);
    if (samplevalue) {
      return samplevalue.exampleValue;
    }
    return '';
  };

  const downloadFlatFiles = (format) => {
    if (selectedTemplate?.variableContract.length > 0) {
      const { hasMoreThanTwoLevels } = dynamicTableHasMoreThanTwoLevels(selectedTemplate.variableContract);
      if (hasMoreThanTwoLevels) {
        message.warning(t(
          TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,
          TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value,
        ));
        return;
      }
    }
    const dataset = getSampleDataSet(selectedTemplate.variableContract, globalVariables,'flatFile', 'live', false);
    const headers = generateCSVHeadersFromJSON(dataset);
    const templateName = selectedTemplate['name'];
    downloadDelimitedFile({ templateName,headers, format: format });
    return;
  }

  const downloadJson = format => {
    let dataSet = { };
    selectedTemplate.variableContract.forEach(variable => {
      dataSet = {
        ...dataSet,
        uniq_id:'',
        uniq_name:''
      };
      if (variable.type === VARIABLE_TYPE.OBJECT) {
        const result = {};

        variable.content.forEach(contentItem => {
          if (contentItem.type === VARIABLE_TYPE.CHART_OBJECT) {
            const chartObject = contentItem.content.reduce((acc, contentItem) => {
              acc[contentItem.name] = getSampleValue(contentItem.variableId);
              return acc;
            }, {});

            result[contentItem.name] = [chartObject];
          } else {
            variable.content.forEach(nonChartContentItem => {
              result[nonChartContentItem.name] = nonChartContentItem.type === VARIABLE_TYPE.STRING
                ? getSampleValue(nonChartContentItem.variableId)
                : (nonChartContentItem.type === VARIABLE_TYPE.CHART_OBJECT || nonChartContentItem.type === VARIABLE_TYPE.OBJECT)
                  ? [{
                      [nonChartContentItem.content[0].name] : 
                        (nonChartContentItem.type === VARIABLE_TYPE.LIST_OF_STRINGS) 
                        ? [getSampleValue(nonChartContentItem.content[0]?.variableId)]
                        :  getSampleValue(nonChartContentItem.content[0]?.variableId)
                    }]
                  : [{
                      [nonChartContentItem.content[0].name]: getSampleValue(nonChartContentItem.content[0]?.variableId)
                    }];
            });
          }
        });

        dataSet = {
          ...dataSet,
          [variable.name]: [result],
        };
      } else if (
        variable.type === VARIABLE_TYPE.CHART_OBJECT ||
        variable.type === VARIABLE_TYPE.FORM_OBJECT
      ) {
        const chartObject = variable.content.reduce((acc, contentItem) => {
          acc[contentItem.name] = getSampleValue(contentItem.variableId);
          return acc;
        }, {});

        dataSet = {
          ...dataSet,
          [variable.name]: [chartObject],
        };
      } else {
        const samplevalue = getSampleValue(variable.variableId);
        dataSet = {
          ...dataSet,
          [variable.name]: variable.type === 'listOfStrings' ? [samplevalue] : samplevalue,
        };
      }
    });

    if (isMailRoomModuleEnabled) {
      const tags = tagsData.map(item => item.tagName);
      tags.forEach(key => {
        dataSet[key.replace(/\s+/g, '_')] = '';
      });
      dataSet.printable = false;
    }
    if (format === 'JSON') {
      jsonToFile([dataSet], `${selectedTemplate['name']}-sample-request`);
    } else if (format === 'xml') {
      const xmlString = getXMLFromJSON({ request: [dataSet] });
      xmlToFile(xmlString, `${selectedTemplate['name']}-sample-request`);
    }
  };

    const handleLimitExceeded = event => {
      event && event.stopPropagation();
      setShowUpgradeModal(true);
    };

  const steps = [
    {
      title: (
        <div>
          {t(
            TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.key,
            TRANSACTIONS.SELECT_A_TEMPLATE_STEP_TITLE.value,
          )}{' '}
          <br />
        </div>
      ),
      content: renderBody(tempCategories, templatesList),
    },
    {
      title: t(
        TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.key,
        TRANSACTIONS.UPLOAD_EXCEL_FILE_STEP_TITLE.value,
      ),
      content: (
        <ErrorMessage
          isError={errorMessage ? 1 : 0}
          width={'100%'}
          downloadZip={false}
          isUploading={isUploading}
          accessMailRoomData={0}
        >
          {selectedTemplate && (
            <TempDetails accessMailRoomData={0}>
              <div className="tempDetail">
                <div>
                  {t(
                    TRANSACTIONS.SELECTED_TEMPLATE_TITLE.key,
                    TRANSACTIONS.SELECTED_TEMPLATE_TITLE.value,
                  )}
                  <p style={{ paddingLeft: 0 }}>{selectedTemplate?.name}</p>
                </div>
                <div>
                  {t(
                    TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.key,
                    TRANSACTIONS.TEMPLATE_VARIABLES_TITLE.value,
                  )}
                  <div className="variables">
                    {selectedTemplate?.variableContract &&
                      getDistinctItemsByVariableId(selectedTemplate?.variableContract).map(
                        (variable, index) => index < 3 && <p>{variable.name}</p>,
                      )}
                    <p
                      className={
                        selectedTemplate?.variableContract?.length === 0
                          ? 'varDetails noVar'
                          : 'varDetails'
                      }
                      onClick={() => {
                        selectedTemplate?.variableContract?.length > 0 && setIsViewVarDetails(true);
                      }}
                    >
                      {selectedTemplate?.variableContract?.length === 0
                        ? t(TRANSACTIONS.NO_VARIABLES.key, TRANSACTIONS.NO_VARIABLES.value)
                        : selectedTemplate?.variableContract?.length > 3
                        ? t(
                            TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.key,
                            TRANSACTIONS.SEE_ALL_TEMPLATE_VARIABLES_ACTION.value,
                          )
                        : t(
                            TRANSACTIONS.TEMPLATE_VARIABLES_DETAILS_ACTION.key,
                            TRANSACTIONS.TEMPLATE_VARIABLES_DETAILS_ACTION.value,
                          )}
                    </p>
                  </div>
                </div>
              </div>

              <div id={'more-options-download'}>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="1" onClick={generateSampleExcel}>
                        Excel
                      </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={e => {
                          downloadJson('JSON');
                        }}
                      >
                        JSON
                      </Menu.Item>
                      <Menu.Item
                        key="3"
                        onClick={e => {
                          downloadJson('xml');
                        }}
                      >
                        XML
                      </Menu.Item>
                      <Menu.Item
                        key="4"
                        onClick={e => {
                          downloadFlatFiles('csv');
                        }}
                      >
                        CSV
                      </Menu.Item>
                      <Menu.Item
                        key="5"
                        onClick={e => {
                          downloadFlatFiles('tsv');
                        }}
                      >
                        TEXT (Tab Delimited)
                      </Menu.Item>
                      <Menu.Item
                        key="6"
                        onClick={e => {
                         downloadFlatFiles('psv');
                        }}
                      >
                        TEXT (Pipe Delimited)
                      </Menu.Item>
                    </Menu>
                  }
                  placement={'bottomRight'}
                  trigger={['hover']}
                  getPopupContainer={() => document.getElementById('more-options-download')}
                >
                  <Button>
                    {t(
                      TRANSACTIONS.DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON.key,
                      TRANSACTIONS.DOWNLOAD_SAMPLE_FILE_FORMAT_BUTTON.value,
                    )}
                    <Icon
                      type="down"
                      style={{ paddingLeft: 10 }}
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    />
                  </Button>
                </Dropdown>
              </div>
            </TempDetails>
          )}

          {isUploading || generatingPdf ? (
            <BulkUploadButton
              isUploading={1}
              // className="generatePDF"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: (isUploading || generatingPdf) && 'pointer',
                }}
              >
                <Icon
                  style={{ marginBottom: isUploading || generatingPdf ? '' : '15px' }}
                  component={PDFSvg}
                />
                <p className={isUploading || generatingPdf ? 'downloadZip' : ''}>
                  <Icon
                    type={isUploading || generatingPdf ? 'loading' : ''}
                    style={{ marginRight: '5px', fontSize: '15px' }}
                  />
                  {isUploading
                    ? t(
                        TRANSACTIONS.UPLOADING_SAMPLE_FILE_DATA.key,
                        TRANSACTIONS.UPLOADING_SAMPLE_FILE_DATA.value,
                      )
                    : generatingPdf
                    ? t(
                        `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.key}`,
                        PDF_TRANSACTIONS.GENERATING_PDF_MESSAGE.value,
                      )
                    : ''}
                </p>
              </div>
            </BulkUploadButton>
          ) : (
            <Upload
              accept=".xls, .xlsx, .json, .xml"
              showUploadList={false}
              className="varUpload"
              beforeUpload={beforeUpload}
              disabled={userDetails.isTransactionFull}
            >
              <BulkUploadButton
                onClick={e => userDetails.isTransactionFull && handleLimitExceeded(e)}
              >               
                <p className="import">
                  {t(
                    TRANSACTIONS.DRAG_AND_DROP_FILE_FORMAT_TITLE.key,
                    TRANSACTIONS.DRAG_AND_DROP_FILE_FORMAT_TITLE.value,
                  )}
                </p>
                <p className="desc">
                  {t(
                    TRANSACTIONS.GENETRATE_BULK_TRANSACTIONS_DESCRIPTION.key,
                    TRANSACTIONS.GENETRATE_BULK_TRANSACTIONS_DESCRIPTION.value,
                  )}
                </p>
              </BulkUploadButton>
            </Upload>
          )}
        </ErrorMessage>
      ),
    },
  ];

  return (
    <Container isUploadFile={1}>
      <TemplateConatiner isUploadFile={1}>
        <div>{renderSearchBody(tempCategories, templatesList)}</div>
        {!isLoading && currentStep === 0 && templatesList?.length > 0 && (
          <>
            {templatesList?.length !== totalTemplates && templatesList.length >= 6 && (
              <div className="addMore">
                <Icon type="loading" />
                {t(
                  TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.key,
                  TRANSACTIONS.LOADING_MORE_TEMPLATES_MESSAGE.value,
                )}
              </div>
            )}
            {templatesList?.length === totalTemplates && templatesList.length !== 0 && (
              <div className="allData">
                {t(
                  TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.key,
                  TRANSACTIONS.GOT_ALL_TEMPLATES_MESSAGE.value,
                )}
              </div>
            )}
          </>
        )}
      </TemplateConatiner>
      {isViewVarDetails && (
        <VariableDetailsModal
          visible={isViewVarDetails}
          isViewTags={false}
          isPublishedMessages={false}
          tagsData={tagsData}
          isMissedVarList={false}
          variables={getDistinctItemsByVariableId(
            selectedTemplate && selectedTemplate?.variableContract,
          )}
          onCancel={() => setIsViewVarDetails(false)}
          isGeneratingPDF={generatingPdf}
          showMaxLength={false}
        />
      )}
      <UpgradePlanModal
        visible={showUpgradeModal}
        modalText={userDetails.planMapping.planName === 'Premium' ?
          t(TRANSACTIONS.PREMIUM_PLAN_LIMIT_REACHED.key, TRANSACTIONS.PREMIUM_PLAN_LIMIT_REACHED.value, { emailId: SUPPORT_EMAIL_ID }) 
        : userDetails.planMapping.planName === 'Free' ?  
          t(TRANSACTIONS.FREE_PLAN_UPGRADE_MESSAGE.key, TRANSACTIONS.FREE_PLAN_UPGRADE_MESSAGE.value, { transactionLimit })
          : t(TRANSACTIONS.STANDARD_PLAN_UPGRADE_MESSAGE.key, TRANSACTIONS.STANDARD_PLAN_UPGRADE_MESSAGE.value, { transactionLimit })}
        onCancel={() => setShowUpgradeModal(false)}
      />
    </Container>
  );
};

export default withTranslation(NAMESPACES)(GeneratePdf);
